import * as React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { InfoSidebar } from '../components/InfoSidebar';
import { TermsContent } from '../components/TermsContent';
import { PrivacyContent } from '../components/PrivacyContent';
import { CookieContent } from '../components/CookieContent';
import { CreatorContent } from '../components/CreatorContent';
import { PageHeader } from '@/components/layout/PageHeader';
import arrowLeft from '@/assets/images/svg/left_arrow.svg';

export const InfoPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const activeTab = searchParams.get('tab') || 'terms';
  const navigate = useNavigate();

  return (
    <div className='flex h-dvh w-full overflow-hidden bg-brand-25'>
      <InfoSidebar />

      <div className='relative flex min-w-0 flex-1 flex-col overflow-hidden'>
        {/* Mobile Header */}
        <div className='flex items-center justify-between bg-white px-4 py-3 shadow-sm md:hidden'>
          <button onClick={() => navigate('/home')} className='p-2'>
            <img src={arrowLeft} alt='Back' className='size-5' />
          </button>
          <span className='font-sans text-16 font-bold text-brand-800'>Legal Info</span>
          <div className='w-9' /> {/* Spacer */}
        </div>

        {/* Desktop Header Area */}
        <div className='hidden px-6 pt-6 md:block md:px-10 md:pt-10'>
          <div className='mx-auto w-full max-w-4xl'>
            <PageHeader
              title='LEGAL INFORMATION'
              titleClassName='text-brand-800'
              theme='dark'
              showNotifications={false}
            />
          </div>
        </div>

        {/* Mobile Tabs */}
        <div className='flex border-b border-gray-200 bg-white md:hidden'>
          <button
            onClick={() => navigate('/info?tab=terms')}
            className={`flex-1 border-b-2 py-3 text-center font-sans text-14 font-medium ${
              activeTab === 'terms'
                ? 'border-brand-800 text-brand-800'
                : 'border-transparent text-gray-500'
            }`}
          >
            Terms
          </button>
          <button
            onClick={() => navigate('/info?tab=privacy')}
            className={`flex-1 border-b-2 py-3 text-center font-sans text-14 font-medium ${
              activeTab === 'privacy'
                ? 'border-brand-800 text-brand-800'
                : 'border-transparent text-gray-500'
            }`}
          >
            Privacy
          </button>
          <button
            onClick={() => navigate('/info?tab=cookie')}
            className={`flex-1 border-b-2 py-3 text-center font-sans text-14 font-medium ${
              activeTab === 'cookie'
                ? 'border-brand-800 text-brand-800'
                : 'border-transparent text-gray-500'
            }`}
          >
            Cookie
          </button>
          <button
            onClick={() => navigate('/info?tab=creator')}
            className={`flex-1 border-b-2 py-3 text-center font-sans text-14 font-medium ${
              activeTab === 'creator'
                ? 'border-brand-800 text-brand-800'
                : 'border-transparent text-gray-500'
            }`}
          >
            Creator
          </button>
        </div>

        <div className='custom-scrollbar flex-1 overflow-y-auto p-6 md:p-10'>
          <div className='mx-auto w-full max-w-4xl rounded-20 bg-white p-6 shadow-sm md:p-8 lg:p-10'>
            {activeTab === 'terms' && <TermsContent />}
            {activeTab === 'privacy' && <PrivacyContent />}
            {activeTab === 'cookie' && <CookieContent />}
            {activeTab === 'creator' && <CreatorContent />}
          </div>
          <div className='h-20' />
        </div>
      </div>
    </div>
  );
};

export default InfoPage;
